


























import VueOptions from '@utils/VueOptions'

settings =
  name: "WaitListSponsor"

  vue:
    store: ['member']

    data:
      timer: null

    created: ->
      hubspotScript = document.createElement('script')
      hubspotScript.setAttribute('src',"https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js")
      document.head.appendChild(hubspotScript)

    mounted: ->
      await @syncMember()
      @timer = setInterval((() => @syncMember()), 30000)

    computed:
      isCampaignsRoute: -> @$route.name.includes('Campaign')

    methods:
      syncMember: ->
        m = await @refetchMember()
        if not m?.wait_listed
          clearInterval(@timer)
          @navigateToDashboard()

      hiLogout: ->
        clearInterval(@timer)
        @logout()

export default VueOptions.vue settings
